// @flow
import moment from 'moment';
import React from 'react';
import { RangePicker } from '../../../components/ant/DatePicker';
import { SectionContent } from '../../../components/hoc/common/components/elements';
import Selects from '../../../components/selects';
import { formatDateTimeToISOString } from '../../../lib/helpers';
import type { OrderContractorType, RepairPlan } from '../../../lib/types';

import { Filter, FilterButtonsContainer, FilterContainer, FilterItem } from './../../../components';
import Field from './../../../components/card/Field';
import type { FilterChildrenParams } from './../../../components/hoc/Filter';

const {
  MaintenanceWorkTypeSelect,
  OrderContractorTypeSelect,
  RepairePlanSelect,
  ExpenseDirectionTreeSelect,
} = Selects;

export type CompareExpenseDirectionFilterParams = {
  maintenanceWorkTypeId?: number,
  orderContractor?: OrderContractorType,
  repairPlan?: RepairPlan,
  expenseDirectionId?: number,
  startDate?: string,
  endDate?: string
};

type Props = {
  filter: CompareExpenseDirectionFilterParams,
  cleanFilter: Function,
  applyFilter: Function
};

export const StockPartFilter = ({
  filter,
  cleanFilter,
  applyFilter
}: Props) => (
  <SectionContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
        additionalFilter={true}
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter,
          showAdditional,
          handleAdditional
        }: FilterChildrenParams<CompareExpenseDirectionFilterParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <MaintenanceWorkTypeSelect
                  value={values.maintenanceWorkTypeId}
                  onChange={value =>
                    changeValue('maintenanceWorkTypeId', value)
                  }
                  size="small"
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <OrderContractorTypeSelect
                  placeholder="Выберите способ выполнения"
                  value={values.orderContractor}
                  onChange={value => changeValue('orderContractor', value)}
                  size="small"
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RepairePlanSelect
                  placeholder="Выберите график работ"
                  value={values.repairPlan}
                  onChange={value => changeValue('repairPlan', value)}
                  size="small"
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <ExpenseDirectionTreeSelect
                  value={values.expenseDirectionId}
                  onChange={value => changeValue('expenseDirectionId', value)}
                  size="small"
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <RangePicker
                  size="small"
                  format="DD.MM.YYYY"
                  placeholder={['Начало', 'Конец']}
                  value={[
                    values.startDate ? moment.utc(values.startDate) : null,
                    values.endDate ? moment.utc(values.endDate) : null
                  ]}
                  onChange={(value, dateString) => {
                    const [startDate, endDate] = value;
                    const [startDateString, endDateString] = dateString;
                    changeValue(
                      'startDate',
                      startDate
                        ? formatDateTimeToISOString(startDate, startDateString)
                        : undefined
                    );
                    changeValue(
                      'endDate',
                      endDate
                        ? formatDateTimeToISOString(endDate, endDateString)
                        : undefined
                    );
                  }}
                />
              </Field>
            </FilterItem>
            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
              handleAdditional={handleAdditional}
              showAdditional={showAdditional}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SectionContent>
);

export default StockPartFilter;
